import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-bashboard_company_flat",
  "use": "icon-bashboard_company_flat-usage",
  "viewBox": "0 0 82 26",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" viewBox=\"0 0 82 26\" id=\"icon-bashboard_company_flat\">\n<polygon points=\"82,13.1 78.2,9.7 78.2,12.2 0,12.2 0,14.2 78.2,14.2 78.2,16.3 \" />\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol